/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Col_ExpiryInputs */

const vi_api_keys_col_expiry = /** @type {(inputs: Api_Keys_Col_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày hết hạn`)
};

/**

* @param {Api_Keys_Col_ExpiryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_col_expiry = /** @type {((inputs?: Api_Keys_Col_ExpiryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Col_ExpiryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_col_expiry(inputs)
});